import type { AuditType, Tables } from "@msuite/utils/types";
import { ProjectTimelineAuditInsertItem } from "./project-timeline-audit-insert-item";
import { ProjectTimelineAuditMergeItem } from "./project-timeline-audit-merge-item";
import { ProjectTimelineAuditUpdateItem } from "./project-timeline-audit-update-item";
import { PorjectTimelineItemMeta } from "./project-timeline-item-meta";

/** Props Interface */
interface ProjectTimelineAuditItemProps {
	type: AuditType;
	item: Tables<"projectsAudit">;
}

export function ProjectTimelineAuditItem({ type, item }: ProjectTimelineAuditItemProps) {
	return (
		<div className="card v-stack overflow-x-hidden">
			<PorjectTimelineItemMeta timestamp={item.changedAt} />
			{type === "audit-insert" && <ProjectTimelineAuditInsertItem item={item} />}
			{type === "audit-update" && <ProjectTimelineAuditUpdateItem item={item} />}
			{type === "audit-merge" && <ProjectTimelineAuditMergeItem item={item} />}
			{type === "audit-delete" &&
				// this state is impossible
				null}
		</div>
	);
}
